/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Countries, CountryCode, Language } from 'shared';

export const findCountryLocalizations = (language: Language) => {
  return Object.entries(Countries).reduce(
    (countries, [countryCode, country]) => {
      countries[countryCode as CountryCode] = {
        callingCode: country.callingCode.toString(),
        name: country.i18n[language],
      };
      return countries;
    },
    {} as Record<CountryCode, Record<'name' | 'callingCode', string>>,
  );
};
